import { render, staticRenderFns } from "./editor-edit-exam-question.vue?vue&type=template&id=799d2d8b&scoped=true&"
import script from "./editor-edit-exam-question.vue?vue&type=script&lang=js&"
export * from "./editor-edit-exam-question.vue?vue&type=script&lang=js&"
import style0 from "./editor-edit-exam-question.vue?vue&type=style&index=0&id=799d2d8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799d2d8b",
  null
  
)

export default component.exports